export default "skymp5-front/98e1ef58cc20d933ecc2fd08a7e97f22.png";